import { BehaviorSubject } from 'rxjs';
let DefaultState = {
    isVisible: false,
    isSubscribed: false,
    sectionId: null,
    conceptId: null,
    sectionName: null,
    conceptName: null
}


class EmailAlertsState extends BehaviorSubject{
    constructor() {
        super(Object.assign({},DefaultState));
        this._state = null;

    }
	get state(){
		if(this._state==null){
			this._state = Object.assign({},DefaultState)
		}
		return this._state;
	}

    get isVisible() {
        return this.state.isVisible;
    }
    set isVisible(flag = this.state.isVisible) {
        if (flag != this.isVisible) {
            this.state.isVisible = flag;
            this.next(this.state);
        }
    }

    get isSubscribed() {
        return this.state.isSubscribed;
    }
    set isSubscribed(flag) {
        if (flag != this.isSubscribed) {
            this.state.isSubscribed = flag;
            this.next(this.state);
        }
    }
    get sectionId() {
        return this.state.sectionId;
    }
    set sectionId(val = null) {
        if (val != this.sectionId) {
            this.state.sectionId = val;
            this.next(this.state);
        }
    }
    get sectionName() {
        return this.state.sectionName;
    }
    set sectionName(val = "") {
        if (val != this.sectionName) {
            this.state.sectionName = val;
            this.next(this.state);
        }
    }
    get conceptId() {
        return this.state.conceptId;
    }
    set conceptId(val = null) {
        if (val != this.conceptId) {
            this.state.conceptId = val;
            this.next(this.state);
        }
    }
    get conceptName() {
        return this.state.conceptName;
    }
    set conceptName(val = "") {
        if (val != this.conceptName) {
            this.state.conceptName = val;
            this.next(this.state);
        }
    }

}

export { EmailAlertsState }